"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("../");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BaseTable = props => {
  const {
    onFlip,
    onLimit,
    onSelect,
    onSelectAll,
    onDelete,
    onErrorRead,
    onChange,
    onAdd,
    onDrop,
    onSort,
    singleTo,
    columns,
    [props.entity]: list
  } = props;
  if (!list.pagination) return /*#__PURE__*/_react.default.createElement(_.Table, {
    columns: columns,
    values: list.data,
    selection: list.selection,
    fetched: list.fetched,
    fetching: list.fetching,
    errors: list.errors,
    singleTo: singleTo,
    onSelect: onSelect,
    onSelectAll: onSelectAll,
    onDelete: onDelete,
    onErrorRead: onErrorRead,
    onChange: onChange,
    onAdd: onAdd,
    onDrop: onDrop,
    onSort: onSort,
    entity: (void 0).props
  });
  return /*#__PURE__*/_react.default.createElement(_.TablePagination, {
    onFlip: onFlip,
    onLimit: onLimit,
    limit: list.limit,
    limits: list.limits || [5, 10, 25, 50, 100, 200],
    page: list.page,
    total: list.total
  }, /*#__PURE__*/_react.default.createElement(_.Table, {
    columns: columns,
    values: list.data,
    selection: list.selection,
    fetched: list.fetched,
    fetching: list.fetching,
    errors: list.errors,
    singleTo: singleTo,
    onSelect: onSelect,
    onSelectAll: onSelectAll,
    onDelete: onDelete,
    onErrorRead: onErrorRead,
    onChange: onChange,
    onAdd: onAdd,
    onDrop: onDrop,
    onSort: onSort,
    entity: (void 0).props
  }));
};
BaseTable.propTypes = process.env.NODE_ENV !== "production" ? {
  onFlip: _propTypes.default.func,
  onLimit: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  onSelectAll: _propTypes.default.func,
  onDelete: _propTypes.default.func,
  onErrorRead: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onAdd: _propTypes.default.func,
  onDrop: _propTypes.default.func,
  onSort: _propTypes.default.func,
  singleTo: _propTypes.default.func,
  columns: _propTypes.default.array,
  entity: _propTypes.default.object
} : {};
var _default = exports.default = BaseTable;
module.exports = exports.default;